import type { Context } from 'react';
import { createContext } from 'react';

type BannerContextValue = {
	includeTopNav: boolean;
	/**
	 * When true, this subtree reports no banners at all: the `useBannerState` hooks read empty and
	 * drop writes. Set by `WithoutBanners` for full-screen overlays.
	 *
	 * Optional on purpose — some call sites build this context value by hand rather than going
	 * through `BannerContextProvider` (e.g. `@confluence/whiteboard`'s embedded route wrapper), so a
	 * required field would break them.
	 */
	suppressed?: boolean;
};

export const BannerContext: Context<BannerContextValue> = createContext<BannerContextValue>({
	includeTopNav: true,
});

BannerContext.displayName = 'BannerContext';
